import { Loader } from 'react-feather';

interface SpinLoaderProps {
    className?: string;
}

export function SpinLoader({ className }: SpinLoaderProps) {
    return (<Loader className={`h-4 w-4 animate-spin text-primary ${className}`} />);
}

interface SpinTextProps extends React.HTMLAttributes<HTMLDivElement> {
    text: string;
}

export function SpinTextLoader({ text, className, ...props }: SpinTextProps) {
    return (
        <div className={`flex items-center gap-2 text-sm text-secondary ${className ?? ''}`} {...props}>
            <SpinLoader />
            <span>{text}</span>
        </div>
    );
}